import * as React from "react";
import { useState, useEffect } from "react";
import {
  Grid,
  FormLabel,
  TextField,
  Typography,
  IconButton,
  Box,
  Select,
  MenuItem,
} from "@mui/material";
import { styled } from "@mui/system";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { useParams } from "react-router-dom";
import {
  getSiteById,
  updateSiteById,
} from "../../services/siteServices/subSiteService";
import {
  getAllCities,
  getLocationByCity,
} from "../../services/siteServices/locationService";
import SiteDetailMap from "../SiteDetailMap/SiteDetailMap";

import {
  getAllCityByPrinciple,
  getAllCorporationByCity,
  getAllPackagesByPrincipleAndCity,
  getPackageByPrincipleAndPackageName,
} from "../../services/siteServices/packageServices";
import SnackBars from "../snackbars/SnackBars";
import { type } from "@testing-library/user-event/dist/type";
import {
  getAllPremiums,
  getAllProcesses,
} from "../../services/PartnerService/PartnerService";

// Custom styled grid for the form layout
const FormGrid = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  padding: "16px",
}));

export default function SiteDetails() {
  const { id } = useParams(); // Fetches the ID from the route params
  const [editMode, setEditMode] = useState(false);
  const [initialForm, setInitialForm] = useState(null);
  const [packages, setPackages] = useState([]);
  const [projectName, setProjectName] = useState("");
  const [showSurrenderDate, setShowSurrenderDate] = useState(true);

  const [formData, setFormData] = useState({
    Zone: "",
    StateName: "",
    CityName: "",
    PackageID: "",
    package_name: "",
    package_rate: "",
    Profile: "",
    PriorityOfCity: "",
    LocationName: "",
    LocationLandmark: "",
    PrincipleUIDCode: "",
    LocationLat: "",
    LocationLong: "",
    corporationName: "",
    site_process: "",
    premiumness: "",
    surrenderDate: "",
  });
  const [cities, setCities] = useState([]);
  const [premiums, setPremiums] = useState([]);
  const [processes, setProcesses] = useState([]);
  const [corporation, setCorporation] = useState([]);
  const [locationId, setLocationid] = useState(""); // List of cities for the dropdown

  // Function to fetch site data by ID
  const getSite = async (id) => {
    const res = await getSiteById(id);
    // console.log("getSite Data", res);

    const projectName = res.ProjectDetails.ProjectName;
    const cityName = res.SiteDetails.CityName;

    fetchCitiesByPrincipleName(projectName); // Load cities when the component mounts
    fetchPackagesByPrincipleAndCity(projectName, cityName);
    fetchCorporationByCity(cityName);

    if (res && res.SiteDetails) {
      const site = res.SiteDetails;

      let obj = {
        Zone: site.Zone || "",
        StateName: site.StateName || "",
        CityName: site.CityName || "",
        // package_name: selectedPackage.packageName || "",
        package_name: res.ProjectDetails.package_name || "",
        package_rate: site.package_rate || "",
        PackageID: site.PackageID || "",
        Profile: site.Profile || "",
        PriorityOfCity: site.PriorityOfCity || "",
        LocationName: site.LocationName || "",
        LocationLandmark: site.LocationLandmark || "",
        PrincipleUIDCode: site.PrincipleUIDCode || "",
        LocationLong: site.LocationLong || "",
        LocationLat: site.LocationLat || "",
        corporationName: site.corporationName || "",
        premiumness: site.premiumness || "",
        site_process: site.site_process || "",
        surrenderDate: site.surrenderDate || "",
      };

      if (!site.surrenderDate) setShowSurrenderDate(false);

      setInitialForm(obj);
      setFormData(obj);
      setProjectName(projectName);
    }
  };

  const fetchCitiesByPrincipleName = async (name) => {
    try {
      const citiesResponse = await getAllCityByPrinciple(name);
      setCities(citiesResponse);
    } catch (error) {
      console.log("error in fetchPackages", error);
    }
  };

  const fetchPackagesByPrincipleAndCity = async (principle, city) => {
    try {
      const packagesResponse = await getAllPackagesByPrincipleAndCity(
        principle,
        city
      );

      setPackages(packagesResponse);
    } catch (error) {
      console.log("error in fetchPackages", error);
    }
  };

  const fetchCorporationByCity = async (name) => {
    try {
      const corporationResponse = await getAllCorporationByCity(name); // Assuming `getCities` API returns a list of cities
      setCorporation(corporationResponse);
    } catch (error) {
      console.log("error in fetchPackages", error);
    }
  };

  // Function to fetch details based on selected city
  const handleCityChange = async (event) => {
    const selectedCity = event.target.value;
    console.log("selected", selectedCity);
    setFormData((prev) => ({
      ...prev,
      // CityName: selectedCity,
      CityName: selectedCity,
      StateName: "",
      Zone: "",
      Profile: "",
      PriorityOfCity: "",
      PackageID: "",
      package_name: "",
      package_rate: "",
      // corporationName: "",
      premiumness: "",
    }));

    try {
      const cityDetails = await getLocationByCity(selectedCity); // Fetch additional data based on the city

      setLocationid(cityDetails[0].LocationID);
      if (cityDetails) {
        setFormData((prev) => ({
          ...prev,
          StateName: cityDetails[0].StateName || "",
          Zone: cityDetails[0].Zone || "",
          Profile: cityDetails[0].Profile || "",
          PriorityOfCity: cityDetails[0].PriorityOfCity || "",
          LocationID: cityDetails[0].LocationID || "",
        }));
      }
      fetchPackagesByPrincipleAndCity(projectName, selectedCity);
      fetchCorporationByCity(selectedCity);
    } catch (error) {
      console.log("error in handleCityChange", error);
    }
  };

  // Toggle edit mode
  const handleEditToggle = () => {
    setEditMode(!editMode);
  };

  const handlePackageChange = async (e) => {
    const { name, value } = e.target;
    let selectedPackage = value;

    setFormData((prev) => ({
      ...prev,
      [name]: selectedPackage,
    }));

    try {
      const packageDetails = await getPackageByPrincipleAndPackageName(
        projectName,
        selectedPackage
      );
      console.log("packageDetails", packageDetails);

      if (packageDetails) {
        // Update state and zone based on the city details
        setFormData((prev) => ({
          ...prev,
          PackageID: packageDetails.PackageID,
          package_name: packageDetails.PackageName,
          package_rate: packageDetails.RatePerSQFT,
        }));
      }
    } catch (error) {
      console.log("error in handlePackageChange", error);
    }
  };

  const handleCancelToggle = () => {
    getSite(id);
    setEditMode(!editMode);
  };

  // Handle input changes during edit mode
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("name and value", name, value);
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle submit (save) and exit edit mode
  const handleSubmit = async () => {
    // Save logic here
    const changedFields = {};

    Object.keys(formData).forEach((key) => {
      if (formData[key] !== initialForm[key]) {
        changedFields[key] = formData[key];
      }
      if (formData[key] === "Surrender") {
        console.log("surrendered please set date");
        changedFields.surrenderDate = new Date().toISOString();
      }
    });

    try {
      if (Object.keys(changedFields).length > 0) {
        const update = await updateSiteById(id, changedFields);
        getSite(id);
      }
      setEditMode(false);
      setOpenSnackBar(true);
      setSnackBarMessage({
        title: "Site Details edited successfully",
        type: "success",
      });
    } catch (error) {
      console.log("error in handleSubmit", error);
    }

    setEditMode(false);
  };

  async function fetchPremiumness() {
    try {
      const response = await getAllPremiums();
      setPremiums(response);
    } catch (error) {
      console.log("fetch Premiumness", error);
    }
  }

  async function fetchProcesses() {
    try {
      const response = await getAllProcesses();
      setProcesses(response);
    } catch (error) {
      console.log("fetch Processes", error);
    }
  }

  // Fetch data on component mount
  useEffect(() => {
    getSite(id);
  }, [id]);

  useEffect(() => {
    // fetchPartners();
    fetchPremiumness();
    fetchProcesses();
  }, []);

  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState({
    title: "",
    type: "",
  });

  const handleCloseSnackBar = () => {
    setOpenSnackBar(false);
  };

  return (
    <Grid container>
      <SnackBars
        open={openSnackBar}
        setOpen={setOpenSnackBar}
        handleClose={handleCloseSnackBar}
        title={snackBarMessage.title}
        type={snackBarMessage.type}
      />
      {/* Edit / Save / Cancel Buttons */}
      <Grid item xs={12} display="flex" justifyContent="flex-end">
        {editMode ? (
          <>
            <IconButton onClick={handleSubmit} sx={{ color: "green" }}>
              <SaveIcon />
            </IconButton>

            <IconButton onClick={handleCancelToggle} sx={{ color: "red" }}>
              <CancelIcon />
            </IconButton>
          </>
        ) : (
          <IconButton onClick={handleEditToggle}>
            <EditIcon />
          </IconButton>
        )}
      </Grid>

      {/* Form fields */}

      {/* Principle UID */}
      <FormGrid xs={12} md={6}>
        <FormLabel htmlFor="PrincipleUIDCode">Principle UID Code</FormLabel>
        {editMode ? (
          <TextField
            id="PrincipleUIDCode"
            name="PrincipleUIDCode"
            value={formData.PrincipleUIDCode}
            onChange={handleChange}
            size="small"
            variant="outlined"
            required
          />
        ) : (
          <Typography>{formData.PrincipleUIDCode}</Typography>
        )}
      </FormGrid>

      {/* City Dropdown */}
      <FormGrid xs={12} md={6}>
        <FormLabel htmlFor="city">City</FormLabel>
        {editMode ? (
          <Select
            id="city"
            name="city"
            value={formData.CityName}
            onChange={handleCityChange}
            size="small"
            variant="outlined"
            required
          >
            {/* console.log("cities data", cities); */}
            {cities.map((city, index) => (
              <MenuItem key={index} value={city.locationName}>
                {city.locationName}
              </MenuItem>
            ))}
          </Select>
        ) : (
          <Typography>{formData.CityName}</Typography>
        )}
      </FormGrid>

      {/* State */}
      <FormGrid xs={12} md={6}>
        <FormLabel htmlFor="StateName">State</FormLabel>
        {editMode ? (
          <TextField
            id="StateName"
            name="StateName"
            value={formData.StateName}
            onChange={handleChange}
            size="small"
            variant="outlined"
            required
            disabled
          />
        ) : (
          <Typography>{formData.StateName}</Typography>
        )}
      </FormGrid>

      {/* Package ID */}
      <FormGrid xs={12} md={6}>
        <FormLabel htmlFor="package_name">Package Name</FormLabel>
        {editMode ? (
          <Select
            id="package_name"
            name="package_name"
            value={formData.package_name} // Set to formData value
            onChange={handlePackageChange}
            size="small"
            variant="outlined"
            required
          >
            {packages.map((pack, index) => (
              <MenuItem key={index} value={pack.packageName}>
                {pack.packageName}
              </MenuItem>
            ))}
          </Select>
        ) : (
          <Typography>{formData.package_name}</Typography>
        )}
      </FormGrid>

      {/* Zone */}
      <FormGrid xs={12} md={6}>
        <FormLabel htmlFor="Zone">Zone</FormLabel>
        {editMode ? (
          <TextField
            id="Zone"
            name="Zone"
            value={formData.Zone}
            onChange={handleChange}
            size="small"
            variant="outlined"
            required
            disabled
          />
        ) : (
          <Typography>{formData.Zone}</Typography>
        )}
      </FormGrid>

      {/* Profile */}
      <FormGrid xs={12} md={6}>
        <FormLabel htmlFor="Profile">Profile</FormLabel>
        {editMode ? (
          <TextField
            id="Profile"
            name="Profile"
            value={formData.Profile}
            onChange={handleChange}
            size="small"
            variant="outlined"
            required
            disabled
          />
        ) : (
          <Typography>{formData.Profile}</Typography>
        )}
      </FormGrid>

      {/* Priority */}
      <FormGrid xs={12} md={6}>
        <FormLabel htmlFor="PriorityOfCity">Priority</FormLabel>
        {editMode ? (
          <TextField
            id="PriorityOfCity"
            name="PriorityOfCity"
            value={formData.PriorityOfCity}
            onChange={handleChange}
            size="small"
            variant="outlined"
            required
            disabled
          />
        ) : (
          <Typography>{formData.PriorityOfCity}</Typography>
        )}
      </FormGrid>

      {/* Asset Location Name */}
      <FormGrid xs={12} md={6}>
        <FormLabel htmlFor="LocationName">Asset Location Name</FormLabel>
        {editMode ? (
          <TextField
            id="LocationName"
            name="LocationName"
            value={formData.LocationName}
            onChange={handleChange}
            size="small"
            variant="outlined"
            required
          />
        ) : (
          <Typography>{formData.LocationName}</Typography>
        )}
      </FormGrid>

      {/* Latitude */}
      <FormGrid xs={12} md={6}>
        <FormLabel htmlFor="LocationLat">Latitude</FormLabel>
        {editMode ? (
          <TextField
            id="LocationLat"
            name="LocationLat"
            value={formData.LocationLat}
            onChange={handleChange}
            size="small"
            variant="outlined"
          />
        ) : (
          <Typography>{formData.LocationLat}</Typography>
        )}
      </FormGrid>

      {/* Longitude */}
      <FormGrid xs={12} md={6}>
        <FormLabel htmlFor="LocationLong">Longitude</FormLabel>
        {editMode ? (
          <TextField
            id="LocationLong"
            name="LocationLong"
            value={formData.LocationLong}
            onChange={handleChange}
            size="small"
            variant="outlined"
          />
        ) : (
          <Typography>{formData.LocationLong}</Typography>
        )}
      </FormGrid>

      {/* Landmark */}
      <FormGrid xs={12} md={6}>
        <FormLabel htmlFor="LocationLandmark">Landmark</FormLabel>
        {editMode ? (
          <TextField
            id="LocationLandmark"
            name="LocationLandmark"
            value={formData.LocationLandmark}
            onChange={handleChange}
            size="small"
            variant="outlined"
          />
        ) : (
          <Typography>{formData.LocationLandmark}</Typography>
        )}
      </FormGrid>

      {/* Corporation Name */}
      <FormGrid xs={12} md={6}>
        <FormLabel htmlFor="corporationName">Corporation Name</FormLabel>
        {editMode ? (
          <Select
            id="corporationName"
            name="corporationName"
            value={formData.corporationName}
            onChange={handleChange}
            size="small"
            variant="outlined"
            required
          >
            {/* console.log("cities data", cities); */}
            {corporation.map((corp, index) => (
              <MenuItem key={index} value={corp.corporationName}>
                {corp.corporationName}
              </MenuItem>
            ))}
          </Select>
        ) : (
          <Typography>{formData.corporationName}</Typography>
        )}
      </FormGrid>

      {/* Premiumness */}
      <FormGrid xs={12} md={6}>
        <FormLabel htmlFor="premiumness">Premiumness</FormLabel>
        {editMode ? (
          <Select
            id="premiumness"
            name="premiumness"
            value={formData.premiumness}
            onChange={handleChange}
            size="small"
            variant="outlined"
            required
          >
            {/* console.log("cities data", cities); */}
            {premiums.map((premium, index) => (
              <MenuItem key={index} value={premium.name}>
                {premium.name}
              </MenuItem>
            ))}
          </Select>
        ) : (
          <Typography>{formData.premiumness}</Typography>
        )}
      </FormGrid>

      {/* Site Process */}
      <FormGrid xs={12} md={6}>
        <FormLabel htmlFor="site_process">Site Process</FormLabel>
        {editMode ? (
          <Select
            id="site_process"
            name="site_process"
            value={formData.site_process}
            onChange={handleChange}
            size="small"
            variant="outlined"
            required
          >
            {/* console.log("cities data", cities); */}
            {processes.map((process, index) => (
              <MenuItem key={index} value={process.name}>
                {process.name}
              </MenuItem>
            ))}
          </Select>
        ) : (
          <Typography>{formData.site_process}</Typography>
        )}
      </FormGrid>

      {/* Surrender Date */}
      {showSurrenderDate && (
        <FormGrid xs={12} md={6}>
          <FormLabel htmlFor="surrenderDate">Surrender Date</FormLabel>
          {editMode ? (
            <TextField
              id="surrenderDate"
              name="surrenderDate"
              value={formData.surrenderDate || ""}
              onChange={handleChange}
              size="small"
              variant="outlined"
              required
            />
          ) : (
            <Typography>{formData.surrenderDate}</Typography>
          )}
        </FormGrid>
      )}

      <SiteDetailMap
        longitude={formData.LocationLong}
        latitude={formData.LocationLat}
      />

      {/* Add spacing between sections */}
      <Box mt={2} />
    </Grid>
  );
}
